<template>
    <div class="col-md-12 panel">
                <loading :active.sync="isLoading" color="#4c4a49" :is-full-page="false"></loading>
                <div class="row">
                    <div class="col-md-12">
                        <div class="panel">
                            <div class="panel-heading">
                                <div class="panel-title hidden-xs">
                                    <span class="glyphicon glyphicon-tasks"></span>Финансы за период <span
                                        id="instructor_name"></span></div>
                            </div>
                            <form v-on:submit.prevent="getReport" class="ng-pristine ng-valid">
                                <div class="panel-body ">
                                    <div class="col-md-4">
                                        <input type="date" v-model="filter.from" class="form-control"
                                               value="" placeholder="Начало периода" required="">
                                    </div>
                                    <div class="col-md-4">
                                        <input type="date" v-model="filter.to" class="form-control"
                                               value="" placeholder="Конец периода" required="">
                                    </div>

                                </div>
                                <div class="panel-footer">
                                    <button type="submit" class="btn btn-primary getstat"> Показать </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <div class="section row" v-if="rows.length > 0">
                    <div class="col-md-12">
                        <div class="panel panel-visible">

                            <div class="panel-body pn">
                                <table class="table table-striped table-hover datatables table-fixed-header" cellspacing="0" width="100%">
                                    <thead>
                                    <tr>
                                        <th>Дата</th>
                                        <th>Наличные</th>
                                        <th>Карта</th>
                                        <th>Приход</th>
                                        <th>Расход</th>
                                        <th><abbr title="Приход минус расход">Итог</abbr></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(row, index) in rows" v-bind:key="index">
                                        <td>{{row.date}}</td>
                                        <td class="sum-cell">{{row.cash | numberFormat()}}</td>
                                        <td class="sum-cell">{{row.card | numberFormat()}}</td>
                                        <td class="sum-cell">{{row.gain | numberFormat()}}</td>
                                        <td class="sum-cell">{{row.less | numberFormat()}}</td>
                                        <td class="sum-cell">{{row.result | numberFormat()}}</td>
                                    </tr>
                                    </tbody>
                                    <tfoot>
                                    <tr v-if="rows.length > 0">
                                        <td>Итого за период</td>
                                        <td class="sum-cell">{{total.cash | numberFormat()}}</td>
                                        <td class="sum-cell">{{total.card | numberFormat()}}</td>
                                        <td class="sum-cell">{{total.gain | numberFormat()}}</td>
                                        <td class="sum-cell">{{total.less | numberFormat()}}</td>
                                        <td class="sum-cell">{{total.result | numberFormat()}}</td>
                                    </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

    </div>
</template>

<script>
    import Report from "../../classes/api/Report";
    import moment from 'moment';

    export default {
        components: {
            Loading: () => import('vue-loading-overlay'),
        },
        mounted() {
            this.getReport();
        },
        computed: {
            total: function() {
                let total = {
                    cash: 0,
                    card: 0,
                    gain: 0,
                    less: 0,
                    result: 0,
                };
                for (let row of this.rows) {
                    total.cash += row.cash;
                    total.card += row.card;
                    total.gain += row.gain;
                    total.less += row.less;
                    total.result += row.result;
                }
                return total;
            },
        },
        data() {
            return {
                isLoading: false,
                filter: {
                    from: moment().format('YYYY-MM-01'),
                    to: moment().format('YYYY-MM-DD'),
                },
                rows: [],
            };
        },
        methods: {
            async getReport() {
                this.isLoading = true;
                let response = await Report.getCashflowInfo(this.filter.from, this.filter.to);
                this.rows = response.data;
                this.isLoading = false;
            },
        },
        metaInfo() {
            return {
                title: 'Отчеты - финансы за период',
                meta: [
                    {vmid: 'description', name: 'description', content: ''},
                    {vmid: 'keywords', name: 'keywords', content: ''},
                ],
            };
        },
    }
</script>
